import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import ProjectCard from './ProjectCard';
import { client } from '../client';
import { Link } from 'react-router-dom';


const Projects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "project"] 
        | order(publishedAt asc)   
        {
          title,
          slug,
          projectType,
          mainImage {
            asset->{
              _id,
              url
            }
          },
          publishedAt
        }`
      )
      .then((data) => {
        // Set the fetched projects in the state
        setProjects(data);
      })
      .catch(console.error);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 1, // Adjust the duration as needed
        delay: 0.5, // Delay the animation by 0.5 seconds
      },
    },
  };

  return (
    <motion.div
      className="mx-auto md:flex items-center justify-between p-4 lg:px-8 text-white mt-32"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="w-full grid md:grid-cols-2 grid-cols-1 gap-4 md:px-0 px-2 overflow-x-hidden">
        {projects.map((project, index) => (
          <div className="col-span-1" key={index}>
                   <Link to={"/" + project.slug.current} key={project.slug.current}>
            <ProjectCard
              bgImage={project.mainImage.asset.url} // Assuming this is the image URL
              projectType={project.projectType}
              title={project.title}
            />
            </Link>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default Projects;
